/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import eMask from 'text-mask-addons/dist/emailMask'
import moment from 'moment'
import _ from 'lodash'
import luhn from 'luhn'
import { INTERNATIONAL_FORMATS, getDateOfBirthFormat, getRegion } from '../../../constants'
import { getMedantaConfigs } from 'configs'

export const emailMask = eMask
export const phoneNumberMask = [ /[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
export const phoneNumberMaskRegex = /^[1-9]\d\d \d\d\d-\d\d\d\d$/
export const phoneNumberMaskRegexNoSymbols = /^[1-9]\d\d\d\d\d\d\d\d\d$/
export const phoneNumberWithPlusOnly = /^['+']?[0-9]*$/
export const phoneNumberMaskRegexFor1Prefix = /^[1-9]\d\d\d\d\d\d\d\d\d\d$/
export const ssnMask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
export const ssnMaskRegexNoSymbols = /^[0-9]\d\d\d\d\d\d\d\d$/

export const getDateOfBirthMask = me => {
  const monthMask = [
    /[JjFfMmAaSsOoNnDd]/, // Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec
    /[A-Za-z]/,
    /[A-Za-z]/,
  ];

  const internationalFormatMask = [
    /\d/,
    /\d/,
    '/',
    ...monthMask,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  if (me) {
    return me && me.data && me.data.teams[0].useIsoTimeFormat
      ? [ /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/ ]
      : [ /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
  }
  return [ /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/ ]
}

export const integerMask = [ /\d/ ]
export const spaceRegex = /^\s*$/

export const requiredValidation = value => (value ? undefined : <FormattedMessage id="validation.message.Required" />)

export const validateMedantaUHIDCheck = (value, p1, props) => {
  const medantaConfigs = getMedantaConfigs(props.me)
  if (medantaConfigs !== null && medantaConfigs.UHIDCheck) {
    if (props.medantaUHIDValidation.Error === true) {
      return props.medantaUHIDValidation.msg
    }
  }
  return undefined
}

export const notJustSpacesValidation = value => (value && spaceRegex.test(value)
  ? <FormattedMessage id="validation.emptySpaces" />
  : undefined)

export const dateValidation = (value, p1, props) => {
  if (value && value !== '--') {
    const mmt = moment(value, getDateOfBirthFormat(props.me), true)
    const now = moment()
    return !(mmt.isValid() && mmt.isBefore(now, 'day') && mmt.isAfter('0001-01-01', 'year'))
      ? <FormattedMessage id="validation.pastDate" />
      : undefined
  } else {
    return undefined
  }
}

export const validateZipCode = value => 
  (value && value.length !== 5 ? <FormattedMessage id="validation.zipcode" /> : undefined)

export const emailValidation = value => (value && !/^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ? <FormattedMessage id="validation.email" />
  : undefined)

export const phoneValidation = value => (value && value.length > 1 && !phoneNumberMaskRegexNoSymbols.test(value.replace(/[()-\s]/g, ''))
  ? <FormattedMessage id="validation.phone" />
  : undefined)

export const numberValidationWithPlusOnly = value => (value && value.length > 1 && !phoneNumberWithPlusOnly.test(value.replace(/[()-\s]/g, ''))
? <FormattedMessage id="validation.numberOnly" />
: undefined)

export const cnPhoneNumber = value => value && !/^['+']?[0-9]*$/.test(value) ? <FormattedMessage id="validation.numberOnly" /> : undefined

export const phoneValidationWith1Prefix = value => (value && value.length > 0 && !phoneNumberMaskRegexFor1Prefix.test(value.replace(/[()-\s]/g, ''))
? <FormattedMessage id="validation.phoneWith1Prefix" />
: undefined)  

export const ssnValidation = value => (value && value.length > 1 && !ssnMaskRegexNoSymbols.test(value.replace(/[()-\s]/g, ''))
  ? <FormattedMessage id="validation.ssn" />
  : undefined)

export const minLenValidationCreator = min => value =>
  (value && value.length < min ? <FormattedMessage id="validation.minLength" values={{
    charCount: min
  }}/> : undefined)

export const minLen1Validation = minLenValidationCreator(1)

export const notesLenValidation = value => (value && value.length > 10000
  ? <FormattedMessage id="validation.maxLength" />
  : undefined)

  /**
   * check if anyone of the given fileds are having isVisible true
   * @param {Object} config 
   * @param {Array} fields 
   * @returns 
   */
  export const checkSectionIsVisible = (config, fields, lookupKey = "isVisible") => {
   return _.isEmpty(config) ? true : fields.some(field => (config[field] || { })[lookupKey])
  }

export const isValidNPI = value => {
  // valid example value = 2345678983
  // generate luhn sequences here http://www.touchoftechnology.com/npi-luhn-check-digit-calculation/
  // npi spec is here:
  // https://www.cms.gov/Regulations-and-Guidance/Administrative-Simplification/NationalProvIdentStand/Downloads/NPIcheckdigit.pdf
  let valid = true;
  if(value) {
    const npiPrefix = '80840';
    const npi = `${npiPrefix}${value}`;
    valid = luhn.validate(npi) && value.length === 10;
  }
  return valid ? '' : <FormattedMessage id="validation.npi" />;
}

export const castStringBooleanToBoolean = str => str.toLowerCase() === 'true'



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/formValidations.js